import moment from "moment";
import DropdownMenubar from "../Components/Menubar/DropdownMenubar";
import { SlCheck } from "react-icons/sl";
import { MdOutlineCancel } from "react-icons/md";

const DD = (MenuItems) => {
  
    return (
      <div className="p-3">
  
        <DropdownMenubar
          menuItem={[
            {
              label: "Action",
              items: MenuItems,
            },
          ]}
          />
      </div>
    );
  };

  const ActionDropDown = (row) => {
  
        return DD([
          {
            label: "Approve",
            icon: <SlCheck style={{color:" rgb(15 61 100)"}} />,
            command: () => {
              // console.log("Approve", row);
            },
          },
          {
            label: "Unapprove",
            icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
            command: () => {
              // console.log("Unapprove", row);
            },
          },
        ])
    }

export const Columns = [
    { field: "createdAt", header: "Date",
      accessor: (row,handleCellClick) => (
        <>
          <div  onClick={()=>handleCellClick(row,"createdAt")}  className="">          
            <p className="w-[6rem]">
                {/* {JSON.stringify(row)} */}
              {moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}
            </p>
          </div>
        </>
      ),
     },
    { field: "Category", header: "Category",
      accessor: (row,handleCellClick) => (
        <>
          <div  onClick={()=>handleCellClick(row,"Category")}  className="">          
            <p className="w-[6rem]">
              {row?.Category?.name || ""}
            </p>
          </div>
        </>
      ),
     },

    { field: "name", header: "Subcategory",
      accessor: (row,handleCellClick) => (
        <>
          <div  onClick={()=>handleCellClick(row,"Subcategory")}  className="">          
            <p className="w-[6rem]">
              {row?.name ||""}
            </p>
          </div>
        </>
      ),
     },

    { field: "status", header: "Status",
      accessor: (row,handleCellClick) => (
        <>
          <div  onClick={()=>handleCellClick(row,"status")}  className="">          
            <p className="w-[6rem]">
              {row?.status ||""}
            </p>
          </div>
        </>
      ),
     },
    //  {
    //     field: "action",
    //     header: "Action",
    //     accessor: (row) => ActionDropDown(row),
    //   },
    
   
    
    
  ];
  
  
  export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export const filters = [
    // {
    //   filterType: "Rating",
    //   inputName: "rating",
    //   options: [
    //     {
    //       name: "5",
    //       code: "5",
    //     },
    //     {
    //       name: "4",
    //       code: "4",
    //     },
    //     {
    //       name: "3",
    //       code: "3",
    //     },
    //     {
    //       name: "2",
    //       code: "2",
    //     },
    //     {
    //       name: "1",
    //       code: "1",
    //     },
       
    //   ],
    // },
   
  ];
  
  
  export const canlenderFilter={
    filterType:"Review Date",
    inputName:"createdAt",  
    maxDate :new Date()
  }